export const getPO = `
  query GetPO($poid: String, $asn: String) {
    getPO(poid: $poid, asn: $asn)
  }
`;

export const postItem = `
  query PostItem($body: String) {
    postItem(body: $body)
  }
`;

export const printItem = `
  query PrintItem($body: String) {
    printItem(body: $body)
  }
`;

const QM_RECORD_FIELDS = `
        qmId
        qmNumber
        type
        status
        reasonCode
        reasonLabel
        closureCode
        closureLabel
        sscc
        asn
        poNumber
        poLine
        supplierCode
        supplierName
        contactName
        itemLocation
        packageCount
        packageType
        description
        closureNotes
        createdBy
        createdAt
        updatedBy
        updatedAt
        closedAt
        statusHistory {
          id
          fromStatus
          toStatus
          changedBy
          changedAt
          note
        }
        changeHistory {
          id
          fieldName
          oldValue
          newValue
          changedBy
          changedAt
        }
  `;

export const createQmRecord = `
  mutation CreateQmRecord($input: CreateQmRecordInput!) {
    createQmRecord(input: $input) {
      ${QM_RECORD_FIELDS}
    }
  }
`;

export const updateQmRecord = `
  mutation UpdateQmRecord($input: UpdateQmRecordInput!) {
    updateQmRecord(input: $input) {
      ${QM_RECORD_FIELDS}
    }
  }
`;

export const getQmRecord = `
  query GetQmRecord($qmId: Int, $qmNumber: String) {
    getQmRecord(qmId: $qmId, qmNumber: $qmNumber) {
      ${QM_RECORD_FIELDS}
    }
  }
`;

export const listQmReferenceReasons = `
  query ListQmReferenceReasons {
    listQmReferenceReasons {
      code
      label
      displayOrder
    }
  }
`;

export const listQmReferenceClosureCodes = `
  query ListQmReferenceClosureCodes($reasonCode: String) {
    listQmReferenceClosureCodes(reasonCode: $reasonCode) {
      code
      label
      reasonCode
      displayOrder
    }
  }
`;

const QM_ATTACHMENT_FIELDS = `
        id
        qmId
        fileName
        mimeType
        sizeBytes
        uploadedBy
        uploadedAt
        downloadUrl
  `;

export const getUploadUrl = `
  query GetUploadUrl($qmId: Int!, $fileName: String!, $mimeType: String) {
    getUploadUrl(qmId: $qmId, fileName: $fileName, mimeType: $mimeType) {
      uploadUrl
      s3Key
    }
  }
`;

export const listAttachments = `
  query ListAttachments($qmId: Int!) {
    listAttachments(qmId: $qmId) {
      ${QM_ATTACHMENT_FIELDS}
    }
  }
`;

export const confirmAttachment = `
  mutation ConfirmAttachment($input: ConfirmAttachmentInput!) {
    confirmAttachment(input: $input) {
      ${QM_ATTACHMENT_FIELDS}
    }
  }
`;
